import React from 'react'
import "./header.min.css"
import {ReactComponent as Logo} from "../icons/logo.svg"
import Navigation from '../navigation/nav'
import { Link } from 'react-router-dom'

const Header = ({ activeLink }) => (
  <div className="Header">
    <div className="Container">
      <div className="Logo container margin-left">
        <Link to="/"><Logo /></Link>
      </div>

      <Navigation
        links={['Home', 'Destination', 'Crew', 'Technology']}
        width='55%'
        height='5.5rem'
        design
        numbers
        active={activeLink}
      />
    </div>
  </div>
)

export default Header